import { keyBy } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { DELETE_CAMPAIGN_GROUP_SUCCESS, SET_CAMPAIGN_GROUP_PICKER_SORTING } from 'modules/campaigns/actions';
import { REPORT_DATA_MAP_VALUES } from 'modules/campaigns/config';
import { defaultSortField, defaultSortType } from 'modules/campaigns/config/campaignGroupSortableFields';
import { createReducer } from 'modules/taboola-common-frontend-modules/utils/reducerUtils';
import updateObject from 'modules/taboola-common-frontend-modules/utils/updateObject';
import { COMPONENT_STATUS } from 'services/constants';
import { addPersistHandler } from 'services/persister';
import {
    updateReportDimensionMapOnError,
    updateReportDimensionMapOnSuccess,
} from '../../../reducer/reportDimensionStateUpdater';
import {
    CREATE_CAMPAIGNS_GROUP_SUCCESS,
    DUPLICATE_CAMPAIGNS_GROUP_ERROR,
    DUPLICATE_CAMPAIGNS_GROUP_SUCCESS,
    FETCH_CAMPAIGN_GROUPS_LIST_ERROR,
    FETCH_CAMPAIGN_GROUPS_LIST_SUCCESS,
    FETCH_CAMPAIGNS_GROUP_FOR_EDIT_ERROR,
    FETCH_CAMPAIGNS_GROUP_FOR_EDIT_SUCCESS,
    REQUEST_FETCH_CAMPAIGN_GROUPS_LIST,
    SAVE_CAMPAIGNS_GROUP_ERROR,
    SAVE_CAMPAIGNS_GROUP_SUCCESS,
} from '../actions';

const REDUCER_NAME = 'campaignsGroupReducer';

export const initialState = {
    [REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS]: {},
    campaignGroupPickerSortingType: defaultSortType,
    campaignGroupPickerSortingField: defaultSortField,
    moduleStatus: COMPONENT_STATUS.INITIAL,
};

const fetchCampaignsGroupForEditSuccessHandler = (state, action) => {
    const extendedCampaignsGroup = { ...action.payload };
    const stateWithUpdatedCampaignsGroup = updateReportDimensionMapOnSuccess(
        state,
        action,
        REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS
    );
    return updateObject(stateWithUpdatedCampaignsGroup, {
        campaignsGroupBeingEdited: extendedCampaignsGroup.campaignsGroupId,
    });
};

const saveCampaignsGroupErrorHandler = (state, action) =>
    updateReportDimensionMapOnError(state, action, REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS);

const saveCampaignsGroupSuccessHandler = (state, action) => {
    const stateWithUpdatedCampaignsGroup = updateReportDimensionMapOnSuccess(
        state,
        action,
        REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS
    );

    return updateObject(stateWithUpdatedCampaignsGroup, {
        campaignsGroupBeingEdited: null,
    });
};

const deleteCampaignGroupSuccessHandler = (state, action) => {
    return updateReportDimensionMapOnSuccess(state, action, REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS);
};

export const fetchCampaignGroupListSuccess = (state, { payload }) => {
    const { results } = payload;
    const fetchedCampaignGroups = keyBy(results, 'id');
    const moduleStatus = COMPONENT_STATUS.ACTIVE;
    return updateObject(state, {
        [REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS]: {
            ...state[REPORT_DATA_MAP_VALUES.CAMPAIGNS_GROUPS],
            ...fetchedCampaignGroups,
        },
        moduleStatus,
    });
};

export const fetchCampaignsGroupRequestHandler = state => {
    if (!isEmpty(state.campaignsGroups)) {
        return state;
    }
    return updateObject(state, {
        moduleStatus: COMPONENT_STATUS.LOADING,
    });
};

const reducer = {
    [REQUEST_FETCH_CAMPAIGN_GROUPS_LIST]: fetchCampaignsGroupRequestHandler,
    [FETCH_CAMPAIGNS_GROUP_FOR_EDIT_SUCCESS]: fetchCampaignsGroupForEditSuccessHandler,
    [FETCH_CAMPAIGN_GROUPS_LIST_SUCCESS]: fetchCampaignGroupListSuccess,
    [FETCH_CAMPAIGN_GROUPS_LIST_ERROR]: state => updateObject(state, { moduleStatus: COMPONENT_STATUS.ERROR }),
    [FETCH_CAMPAIGNS_GROUP_FOR_EDIT_ERROR]: state => updateObject(state, { campaignsGroupBeingEdited: null }),
    [SAVE_CAMPAIGNS_GROUP_SUCCESS]: saveCampaignsGroupSuccessHandler,
    [CREATE_CAMPAIGNS_GROUP_SUCCESS]: saveCampaignsGroupSuccessHandler,
    [DELETE_CAMPAIGN_GROUP_SUCCESS]: deleteCampaignGroupSuccessHandler,
    [SAVE_CAMPAIGNS_GROUP_ERROR]: saveCampaignsGroupErrorHandler,
    [SET_CAMPAIGN_GROUP_PICKER_SORTING]: (state, action) => ({ ...state, ...action.payload }),
    [DUPLICATE_CAMPAIGNS_GROUP_SUCCESS]: saveCampaignsGroupSuccessHandler,
    [DUPLICATE_CAMPAIGNS_GROUP_ERROR]: saveCampaignsGroupErrorHandler,
};

const campaignsGroupReducer = createReducer(initialState, addPersistHandler(reducer, REDUCER_NAME));

export default campaignsGroupReducer;
export { reducer };
